module.exports = __webpack_public_path__ + "723043ca0e1c64660279e8be6bbe6ee6.png";